import { useQuery } from "@tanstack/react-query";

import {
	MeterStatusThreshold,
	MeterStatusThresholdDraft,
} from "../models/MeterStatusThreshold";
import { getMeterStatusThresholds } from "../repositories/MeterStatusThresholdsRepository";
import { DEFAULT_METER_STATUS_THRESHOLDS } from "../utils/meterStatusLevels";

const toMeterStatusDrafts = (
	thresholds: MeterStatusThreshold[] | undefined,
): MeterStatusThresholdDraft[] =>
	DEFAULT_METER_STATUS_THRESHOLDS.map(
		(fallback) =>
			thresholds?.find(
				(threshold) =>
					threshold.Metric === fallback.Metric &&
					threshold.Level === fallback.Level,
			) ?? fallback,
	);

export const useMeterStatusThresholds = () => {
	const query = useQuery<MeterStatusThreshold[], Error>({
		queryKey: ["meterStatusThresholds"],
		queryFn: ({ signal }) => getMeterStatusThresholds(signal),
		staleTime: 30 * 60 * 1000,
	});

	const drafts: MeterStatusThresholdDraft[] = toMeterStatusDrafts(query.data);

	return { ...query, drafts };
};
